<template>
  <div>
    <el-container>
      <el-header width="500px" height="100px">
        <el-menu
          default-active="1"
          class="el-menu-demo"
          mode="horizontal">
          <el-menu-item index="1" @click="addUser">
            <i class="el-icon-circle-plus-outline"></i>
            <span slot="title">添加临时用户</span>
          </el-menu-item>
          <el-menu-item index="2" @click="allTempUser">
            <i class="el-icon-document"></i>
            <span slot="title">查看临时用户</span>
          </el-menu-item>
        </el-menu>
      </el-header>
      <el-main class="main">
        <router-view/>
      </el-main>
    </el-container>
  </div>
</template>

<script>
  import addTempUser from './tempuser/AddTempUser'
  import allTempUser from './tempuser/AllTempUser'

  export default {
    mounted() {
      this.$router.push({'name': 'addTempUser'})
    },
    name: 'version',
    methods: {
      addUser() {
        this.$router.push({'name': 'addTempUser'})
      },
      allTempUser() {
        this.$router.push({'name': 'allTempUser'})
      }
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/TempUser.vue